<div class="bc-row">
    <div class="bc-col-1"></div>
    <div class="bc-col-10">
        <bc-input-file title="Adjuntar archivos" [dropArea]=true (getFilesAdded)='metodoParaCogerLosArchivos($event)'
            [multipleFiles]=false [validType]='[extensionesPermitidas]' [maxFiles]="maxArchivos"
            [buttonLabel]="'Seleccionar archivo'" componentId="InputFileDetalleFactura" #InputFileDetalleFactura>
        </bc-input-file>
    </div>
    <div class="bc-col-1"></div>
</div>

<div class="bc-mt-4 bc-row" *ngIf="archivo.length > 0">
    <div class="bc-col-4"></div>
    <div class="bc-col-4">
        <button bc-button typeButton="background" sizeButton="small" (click)="confirmarAdjuntarArchivo()">Adjuntar
            documento</button>
    </div>
    <div class="bc-col-4"></div>
</div>

<div>
    <bc-modal typeIcon="info" customWidth="small" titleAlign="center" [isCancellable]="confirmAction"
        [subTitle]="confirmSubTitle" [buttonAlignment]="confirmButtonAlignment" textBtn="Sí" textBtnLeft="No"
        typeNotify="success" [displayButton]="confirmDisplayButton" [outerCloseTap]="confirmOuterCloseTap"
        (stateClick)="onPressButton($event)" #confirmacion>
    </bc-modal>
</div>